const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageNotFoundImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-22",
    d: "M86.61,260.74c-90.24,52.1-90.24,136.57,0,188.67s236.55,52.1,326.78,0,90.24-136.57,0-188.67S176.84,208.65,86.61,260.74Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.54,51h11.3a6.59,6.59,0,0,1-.09-1.09V47.48c0-4.37,4.09-7.91,9.13-7.91a10,10,0,0,1,5.45,1.57c.83-5.86,6.57-10.39,13.56-10.39,7.55,0,13.67,5.3,13.67,11.83v3.68A10.49,10.49,0,0,1,109.4,51h9.39c2.8,0,5.07,2,5.07,4.38s-2.27,4.39-5.07,4.39H57.54c-2.8,0-5.07-2-5.07-4.39S54.74,51,57.54,51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.43,95.1H67.3a4.92,4.92,0,0,0,.07-.78V92.56c0-3.15-2.94-5.69-6.57-5.69A7.29,7.29,0,0,0,56.88,88c-.59-4.21-4.73-7.47-9.75-7.47-5.43,0-9.83,3.81-9.83,8.52v2.64a7.54,7.54,0,0,0,.83,3.42H31.38a3.19,3.19,0,1,0,0,6.31H75.43a3.19,3.19,0,1,0,0-6.31Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.66,110.75H413a6.57,6.57,0,0,1-.1-1.08v-2.46c0-4.37,4.09-7.91,9.14-7.91a10,10,0,0,1,5.44,1.57C428.28,95,434,90.48,441,90.48c7.55,0,13.67,5.3,13.67,11.84V106a10.49,10.49,0,0,1-1.16,4.76h9.39c2.8,0,5.07,2,5.07,4.39s-2.27,4.39-5.07,4.39H401.66c-2.8,0-5.07-2-5.07-4.39S398.86,110.75,401.66,110.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.7,62.74h-8.13a4.9,4.9,0,0,0,.07-.77V60.2c0-3.14-2.95-5.69-6.57-5.69a7.19,7.19,0,0,0-3.92,1.13c-.6-4.21-4.73-7.48-9.75-7.47-5.43,0-9.83,3.81-9.83,8.51v2.64a7.51,7.51,0,0,0,.83,3.42h-6.75a3.19,3.19,0,1,0,0,6.32H462.7a3.19,3.19,0,1,0,0-6.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.66,53.7H363a7.18,7.18,0,0,0,.09-1V50.29c0-4.21-3.94-7.62-8.8-7.62a9.68,9.68,0,0,0-5.24,1.51c-.8-5.63-6.33-10-13.06-10-7.27,0-13.16,5.1-13.16,11.4v3.54a10.09,10.09,0,0,0,1.11,4.58h-4.63c-2.69,0-4.88,1.89-4.88,4.23s2.19,4.22,4.88,4.22h50.35c2.69,0,4.88-1.89,4.88-4.22S372.35,53.7,369.66,53.7Z",
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.17,348.77a4.91,4.91,0,0,0-1.78-4.94c-2-1.64-4.64-2.31-4.9-2.15s0,2.88,2.06,5.07A5.73,5.73,0,0,0,34.17,348.77Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.34,355a5,5,0,0,0-3.85-3.59c-2.51-.56-5.19.05-5.35.31s1.32,2.56,4.15,3.58A5.83,5.83,0,0,0,35.34,355Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.14,356a4.91,4.91,0,0,0,2.88-4.4c.13-2.55-.71-4.92-1-5s-2.56,1.91-3.2,4.52A5.17,5.17,0,0,0,40.14,356Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.92,377.59a20,20,0,0,0,.16-6.9,38.72,38.72,0,0,0-1.2-6.32,50.42,50.42,0,0,0-5.24-12.3,27.23,27.23,0,0,0-5.28-6.83s-.16.06-.12.1a40.86,40.86,0,0,1,4.32,6.52,47.7,47.7,0,0,1,3.11,6.28,48.48,48.48,0,0,1,3,11.49,68.54,68.54,0,0,1,.37,7.85A.43.43,0,0,0,42.92,377.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.64,358a15.75,15.75,0,0,0,1.23-3.25,8.83,8.83,0,0,0,.34-3.31c0-.15-.14.05-.16.15a24.31,24.31,0,0,1-.7,2.89A11.28,11.28,0,0,1,39,357.32a.71.71,0,0,0,0,.8A.38.38,0,0,0,39.64,358Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.38,357.64a12.93,12.93,0,0,0-3.84-3,14.88,14.88,0,0,0-2-.95,8.7,8.7,0,0,0-2.56-.6s-.24.08-.18.1a24,24,0,0,1,2.42.9,13.66,13.66,0,0,1,2.07,1.11A20.22,20.22,0,0,1,39,358.13C39.19,358.35,39.56,357.86,39.38,357.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.87,363.84a4.93,4.93,0,0,0-3-4.31c-2.33-1.07-5.08-1-5.29-.81s.75,2.78,3.31,4.37A5.77,5.77,0,0,0,38.87,363.84Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.28,367.23a12.67,12.67,0,0,0-3.14-3.68,13.57,13.57,0,0,0-1.77-1.35A8.61,8.61,0,0,0,35,361.08s-.25,0-.19.05A23.91,23.91,0,0,1,37,362.52a13.62,13.62,0,0,1,1.8,1.51,21.23,21.23,0,0,1,3,3.59C42,367.89,42.41,367.48,42.28,367.23Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.62,337a5.35,5.35,0,0,1,1-5.63c1.79-2.13,4.51-3.37,4.82-3.25s.55,3.08-1.22,5.82A6.27,6.27,0,0,1,50.62,337Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6,343.86A5.33,5.33,0,0,1,54,339.29c2.57-1.09,5.56-1,5.78-.7s-.92,3-3.75,4.63A6.24,6.24,0,0,1,50.6,343.86Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.64,345.8a5.34,5.34,0,0,1-3.93-4.14c-.63-2.71-.19-5.4.09-5.58s3.11,1.55,4.31,4.22A5.61,5.61,0,0,1,45.64,345.8Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.87,369.44a21.91,21.91,0,0,1-1.51-7.35,41.72,41.72,0,0,1,.06-7A54.11,54.11,0,0,1,48.63,341a29.14,29.14,0,0,1,4.31-8.32c0-.05.19,0,.16.08a43.57,43.57,0,0,0-3.36,7.81,50.89,50.89,0,0,0-2.1,7.3,52.71,52.71,0,0,0-1,12.87,73.41,73.41,0,0,0,1.13,8.46A.47.47,0,0,1,46.87,369.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.57,347.86a17.75,17.75,0,0,1-2-3.24,9.62,9.62,0,0,1-1-3.46c0-.17.16,0,.2.12a26.83,26.83,0,0,0,1.3,3,12.42,12.42,0,0,0,2,2.78.75.75,0,0,1,.11.86A.4.4,0,0,1,46.57,347.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.78,347.44a13.64,13.64,0,0,1,3.53-3.9,15.05,15.05,0,0,1,2-1.41A9.65,9.65,0,0,1,54.9,341s.27,0,.21.06a24.57,24.57,0,0,0-2.4,1.44,14.52,14.52,0,0,0-2,1.58,22.34,22.34,0,0,0-3.37,3.79C47.12,348.16,46.63,347.7,46.78,347.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.52,354a5.33,5.33,0,0,1,2.39-5.18c2.28-1.6,5.23-2.08,5.5-1.88s-.27,3.11-2.69,5.3A6.28,6.28,0,0,1,48.52,354Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.54,358.25a13.79,13.79,0,0,1,2.64-4.55,15.22,15.22,0,0,1,1.63-1.78,9.42,9.42,0,0,1,2.33-1.66s.27,0,.21,0a27.66,27.66,0,0,0-2.05,1.91,15.08,15.08,0,0,0-1.63,2,22.91,22.91,0,0,0-2.5,4.42C46,358.89,45.45,358.54,45.54,358.25Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.08,348.77a4.93,4.93,0,0,1,1.78-4.94c2-1.64,4.64-2.31,4.9-2.15s0,2.88-2.05,5.07A5.75,5.75,0,0,1,467.08,348.77Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.92,355a4.93,4.93,0,0,1,3.85-3.59c2.5-.56,5.19.05,5.34.31s-1.32,2.56-4.15,3.58A5.8,5.8,0,0,1,465.92,355Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.11,356a4.92,4.92,0,0,1-2.88-4.4c-.12-2.55.72-4.92,1-5s2.56,1.91,3.21,4.52A5.14,5.14,0,0,1,461.11,356Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.34,377.59a20.24,20.24,0,0,1-.17-6.9,37.7,37.7,0,0,1,1.21-6.32,49.66,49.66,0,0,1,5.24-12.3,27,27,0,0,1,5.27-6.83c.05,0,.17.06.13.1a40.32,40.32,0,0,0-4.33,6.52,46.47,46.47,0,0,0-3.1,6.28,48,48,0,0,0-3,11.49,66.34,66.34,0,0,0-.37,7.85A.43.43,0,0,1,458.34,377.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.62,358a15.2,15.2,0,0,1-1.23-3.25,8.83,8.83,0,0,1-.34-3.31c0-.15.14.05.16.15a26.38,26.38,0,0,0,.69,2.89,11.63,11.63,0,0,0,1.35,2.85.68.68,0,0,1,0,.8A.37.37,0,0,1,461.62,358Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.87,357.64a12.85,12.85,0,0,1,3.85-3,14.76,14.76,0,0,1,2-.95,8.83,8.83,0,0,1,2.57-.6s.23.08.17.1a23.84,23.84,0,0,0-2.41.9,14.3,14.3,0,0,0-2.08,1.11,20.22,20.22,0,0,0-3.68,2.89C462.07,358.35,461.69,357.86,461.87,357.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.38,363.84a4.93,4.93,0,0,1,3-4.31c2.34-1.07,5.09-1,5.3-.81s-.76,2.78-3.31,4.37A5.79,5.79,0,0,1,462.38,363.84Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,367.23a12.67,12.67,0,0,1,3.14-3.68,13.57,13.57,0,0,1,1.77-1.35,8.74,8.74,0,0,1,2.38-1.12s.25,0,.2.05a25.51,25.51,0,0,0-2.18,1.39,12.88,12.88,0,0,0-1.79,1.51,20.85,20.85,0,0,0-3,3.59C459.31,367.89,458.84,367.48,459,367.23Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.63,337a5.34,5.34,0,0,0-.94-5.63c-1.79-2.13-4.51-3.37-4.82-3.25s-.56,3.08,1.21,5.82A6.29,6.29,0,0,0,452.63,337Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.66,343.86a5.36,5.36,0,0,0-3.42-4.57c-2.56-1.09-5.55-1-5.77-.7s.91,3,3.74,4.63A6.26,6.26,0,0,0,452.66,343.86Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.62,345.8a5.33,5.33,0,0,0,3.92-4.14c.63-2.71.2-5.4-.09-5.58s-3.1,1.55-4.3,4.22A5.58,5.58,0,0,0,457.62,345.8Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.38,369.44a21.68,21.68,0,0,0,1.52-7.35,41.72,41.72,0,0,0-.06-7A54.52,54.52,0,0,0,454.63,341a29.16,29.16,0,0,0-4.32-8.32c0-.05-.19,0-.15.08a43.44,43.44,0,0,1,3.35,7.81,50.88,50.88,0,0,1,2.11,7.3,52.71,52.71,0,0,1,1,12.87,75.67,75.67,0,0,1-1.13,8.46A.47.47,0,0,0,456.38,369.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.68,347.86a16.7,16.7,0,0,0,1.95-3.24,9.62,9.62,0,0,0,1-3.46c0-.17-.16,0-.19.12a28.93,28.93,0,0,1-1.31,3,12.42,12.42,0,0,1-2,2.78.76.76,0,0,0-.11.86A.4.4,0,0,0,456.68,347.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.48,347.44a13.83,13.83,0,0,0-3.54-3.9,15,15,0,0,0-2-1.41,9.7,9.7,0,0,0-2.63-1.13s-.27,0-.21.06a24.69,24.69,0,0,1,2.41,1.44,14.39,14.39,0,0,1,2,1.58,22.86,22.86,0,0,1,3.38,3.79C456.13,348.16,456.63,347.7,456.48,347.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.73,354a5.34,5.34,0,0,0-2.38-5.18c-2.29-1.6-5.24-2.08-5.5-1.88s.27,3.11,2.69,5.3A6.26,6.26,0,0,0,454.73,354Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.72,358.25a14,14,0,0,0-2.64-4.55,16.15,16.15,0,0,0-1.63-1.78,9.61,9.61,0,0,0-2.33-1.66s-.27,0-.22,0a25.81,25.81,0,0,1,2.05,1.91,14.31,14.31,0,0,1,1.63,2,23,23,0,0,1,2.51,4.42C457.23,358.89,457.81,358.54,457.72,358.25Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-22"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-22",
    cx: 241.58,
    cy: 433.2,
    rx: 53.71,
    ry: 31.01,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-22",
    cx: 409.44,
    cy: 383.28,
    rx: 53.71,
    ry: 31.01,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-22",
    cx: 91.11,
    cy: 383.28,
    rx: 53.71,
    ry: 31.01,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.56,119.91l-.25-9.51s19.06-2.54,17-22.32c-1.27-12.35-7.94-21.91-46.77-20.81-42.86,1.22-39,26.89-34.23,34.18,7.12,11,24.42,12.21,55.08,10.51l7.7,8.52A.82.82,0,0,0,272.56,119.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.7,121.9l-8.5-9.4c-30.94,1.71-48.11.29-55.3-10.76-2.64-4.07-3.9-12.71.22-20.57,3.27-6.23,11.9-13.79,34.45-14.43,37.37-1,45.92,7.75,47.3,21.29,1.88,18.29-14,22.24-17,22.82l.28,10.48A.82.82,0,0,1,271.7,121.9Zm-8.05-10.49,8.4,9.29-.29-10.76.48-.07c.75-.1,18.52-2.71,16.58-21.73-1.12-10.92-5.59-21.49-46.22-20.34-17.44.5-29,5.29-33.53,13.86-3.92,7.46-2.78,15.64-.28,19.5,6.92,10.64,23.92,12,54.61,10.27Z",
    style: {
      fill: "#37474F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.15,82.85a7.1,7.1,0,0,1,2.41.37,5.89,5.89,0,0,1,1.75.92,4.1,4.1,0,0,1,1.05,1.22,3,3,0,0,1,.4,1.26.42.42,0,0,1-.15.4.6.6,0,0,1-.4.15h-1.44a.85.85,0,0,1-.52-.13,1.42,1.42,0,0,1-.32-.36,2.58,2.58,0,0,0-.93-.89,3.65,3.65,0,0,0-1.85-.38,4.76,4.76,0,0,0-1,.11,3.2,3.2,0,0,0-.84.33,1.68,1.68,0,0,0-.56.53,1.17,1.17,0,0,0-.21.69,1.37,1.37,0,0,0,.2.77,1.45,1.45,0,0,0,.65.51,6.22,6.22,0,0,0,1.22.4c.51.13,1.14.27,1.89.43a13.21,13.21,0,0,1,2.12.63,5.21,5.21,0,0,1,1.46.86,3.38,3.38,0,0,1,.84,1.16,3.93,3.93,0,0,1,.27,1.5,3.6,3.6,0,0,1-.41,1.71,4,4,0,0,1-1.17,1.35,5.75,5.75,0,0,1-1.86.89,8.71,8.71,0,0,1-2.48.33,8.34,8.34,0,0,1-2.2-.28,6.32,6.32,0,0,1-1.85-.8,4.23,4.23,0,0,1-1.3-1.26,3.29,3.29,0,0,1-.56-1.64.47.47,0,0,1,.16-.4.59.59,0,0,1,.4-.15h1.43a1,1,0,0,1,.54.12.94.94,0,0,1,.3.37,3.46,3.46,0,0,0,.35.53,1.91,1.91,0,0,0,.56.48,3.23,3.23,0,0,0,.87.33,5.27,5.27,0,0,0,1.3.14,7.75,7.75,0,0,0,1.19-.09,3.92,3.92,0,0,0,1-.31,2.14,2.14,0,0,0,.7-.54,1.16,1.16,0,0,0,.27-.78,1,1,0,0,0-.29-.74,2.21,2.21,0,0,0-.87-.49,10.87,10.87,0,0,0-1.45-.39c-.57-.13-1.24-.28-2-.48a9.91,9.91,0,0,1-1.79-.58,4.24,4.24,0,0,1-1.27-.83,3,3,0,0,1-.75-1.16,4.65,4.65,0,0,1-.25-1.59,3.65,3.65,0,0,1,.41-1.7A4.12,4.12,0,0,1,220.29,84a5.51,5.51,0,0,1,1.71-.87A7.12,7.12,0,0,1,224.15,82.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,86.54a5.74,5.74,0,0,1,2,.35,4.75,4.75,0,0,1,1.58,1,4.92,4.92,0,0,1,1.07,1.44,4.73,4.73,0,0,1,.46,1.76c0,.12,0,.28,0,.47v1.14c0,.18,0,.34,0,.46a5.39,5.39,0,0,1-.47,1.76,4.56,4.56,0,0,1-1.06,1.43,4.9,4.9,0,0,1-1.58,1,6.12,6.12,0,0,1-4.08,0,5,5,0,0,1-1.58-1,4.53,4.53,0,0,1-1.05-1.43,4.93,4.93,0,0,1-.47-1.76c0-.12,0-.28,0-.46s0-.37,0-.56,0-.39,0-.58a4.61,4.61,0,0,1,0-.47,4.54,4.54,0,0,1,.46-1.76,4.72,4.72,0,0,1,1.06-1.44,4.85,4.85,0,0,1,1.58-1A5.74,5.74,0,0,1,237,86.54Zm2.48,4.61a2.6,2.6,0,0,0-.3-1.05,1.91,1.91,0,0,0-.58-.67,2.17,2.17,0,0,0-.76-.34,4,4,0,0,0-1.68,0,2.17,2.17,0,0,0-.76.34,1.91,1.91,0,0,0-.58.67,2.6,2.6,0,0,0-.3,1.05c0,.11,0,.25,0,.41s0,.34,0,.51,0,.36,0,.53,0,.3,0,.4a2.6,2.6,0,0,0,.3,1,1.91,1.91,0,0,0,.58.67,2.17,2.17,0,0,0,.76.34,4,4,0,0,0,1.68,0,2.17,2.17,0,0,0,.76-.34,1.91,1.91,0,0,0,.58-.67,2.6,2.6,0,0,0,.3-1,3.9,3.9,0,0,0,0-.4v-1C239.52,91.4,239.51,91.26,239.5,91.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.51,89.2a2.46,2.46,0,0,0-1.78.55,2.43,2.43,0,0,0-.54,1.77v5.33a.57.57,0,0,1-.16.39.54.54,0,0,1-.39.17h-1.56a.58.58,0,0,1-.56-.56V87.3a.58.58,0,0,1,.56-.56h1.56a.54.54,0,0,1,.39.17.57.57,0,0,1,.16.39v.47a4.13,4.13,0,0,1,1.14-.76,3.92,3.92,0,0,1,1.59-.27h.92a.54.54,0,0,1,.39.17.53.53,0,0,1,.16.39v1.35a.55.55,0,0,1-.55.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.08,89.2a2.46,2.46,0,0,0-1.78.55,2.43,2.43,0,0,0-.54,1.77v5.33a.54.54,0,0,1-.17.39.5.5,0,0,1-.38.17h-1.56a.58.58,0,0,1-.56-.56V87.3a.58.58,0,0,1,.56-.56h1.56a.5.5,0,0,1,.38.17.54.54,0,0,1,.17.39v.47A4,4,0,0,1,256.9,87a3.92,3.92,0,0,1,1.59-.27h.92a.54.54,0,0,1,.39.17.53.53,0,0,1,.16.39v1.35a.55.55,0,0,1-.55.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.9,96.83l-4.06-9.39a.59.59,0,0,1,0-.14.54.54,0,0,1,.17-.39.52.52,0,0,1,.39-.17h1.53a.61.61,0,0,1,.43.17.8.8,0,0,1,.25.33l2.73,6.33L269,87.24a.9.9,0,0,1,.25-.33.63.63,0,0,1,.43-.17h1.54a.54.54,0,0,1,.39.17.53.53,0,0,1,.16.39.59.59,0,0,1,0,.14L266,100.81a.8.8,0,0,1-.25.33.6.6,0,0,1-.43.16h-1.53a.53.53,0,0,1-.39-.16.54.54,0,0,1-.17-.39.61.61,0,0,1,0-.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,94.49a.58.58,0,0,1,.56.56v1.8a.58.58,0,0,1-.56.56h-1.76a.54.54,0,0,1-.39-.17.53.53,0,0,1-.16-.39v-1.8a.53.53,0,0,1,.16-.39.54.54,0,0,1,.39-.17Zm.45-1.78a.55.55,0,0,1-.55.55h-1.56a.55.55,0,0,1-.55-.55v-9.1a.53.53,0,0,1,.16-.39.54.54,0,0,1,.39-.17h1.56a.54.54,0,0,1,.39.17.53.53,0,0,1,.16.39Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.66,396c.34,3.4.93,5.73,2.26,7.67s3.72,2.48,6.09,1.79a9,9,0,0,0,5.94-5.33,14.12,14.12,0,0,0,.21-8.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.39,373.43c.55,2.26.82,3.8,1.57,6.91,1.17,4.8,2.41,6.84,3.12,10.84.81,4.57.34,6.79-1.45,9.5s-7.36,5.81-10.43,1.95c-2.51-3.14-2.75-6.74-2.72-11.33a98.33,98.33,0,0,0-.79-11.62v-.07c-.12-1.23-.32-3.65-.5-4.87-.39-2.69,1.44-3,2.16-3.37a10.36,10.36,0,0,1,3.19-1.16,9.72,9.72,0,0,1,3.44.15C440.26,370.61,440.86,371.26,441.39,373.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.32,381.74A3.11,3.11,0,0,0,366,385c1.37,1.08,5.36,2.79,10.54,2s7.94-2.44,10-4.18,4.88-4.2,7.21-4.77c2.17-.53,5-1.72,5.7-2.4S400,372,400,372Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.5,362.71a1.38,1.38,0,0,1,.69.16,2.12,2.12,0,0,1,.77,1.73,6.91,6.91,0,0,0,.25,1.7,13.66,13.66,0,0,1,.68,6.73c-.36,1.47-4.28,2.8-6.53,3.7a29.08,29.08,0,0,0-7.24,4.71,21.87,21.87,0,0,1-10.85,4.27c-5.16.23-8.55-1-9.64-2.78-1.35-2.18-.38-3.49,5.48-6.33,1.11-.54,5-2.91,6.32-3.77a31.59,31.59,0,0,0,4-3,22.85,22.85,0,0,0,1.76-1.79,23.68,23.68,0,0,1,2.86-2.51,14.64,14.64,0,0,1,2.21-1.63,9.89,9.89,0,0,1,4.22-1.18c1.5-.1,2.93.2,4.43.05C397.07,362.73,397.29,362.71,397.5,362.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.78,372.24c-1.15-9.91-.35-20.89-1.84-36.37h0c-.24-4-.56-8.24-1-12-1.44-12.7-3.66-17-3.95-19.42,0,0-.13-25-2.13-52.85-.93-13.1-5-16.91-8.47-23.74l-39,1.53c-3.48,17.35-2.68,56.48-1.83,74.18.43,9,2.78,41.4,2.9,56.08,0,4.31-.83,5.86-2.36,7.58-3.21,3.61-7.34,6.18-11.27,9-1.09,2.35,4.41,3.72,9,1.21,3.88-2.13,8.33-4.73,9.66-5.75,3.35-2.61,7-4.37,7.64-8.06.27-1.5,7.32-36,7.45-43.47a171.59,171.59,0,0,0-1.14-17.36l3.2-27.47s4.29,20.93,6.84,32,5.37,24.18,8.28,35.12h0c2.89,12.61,6.78,24.83,7.64,31.17.24,1.51,2.63,16.35,3.51,19.73s8.6,3.16,8.85-2.73C442.93,386.67,441,374.1,440.78,372.24Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.49,228.09c4.75,7.62,8.3,13.85,9.69,37s1.26,37.24,1.47,40,1.69,4.83,3.74,18.54,1,30.4,1,30.4-1.31,2.55-6.75,3.25c-5,.64-7.59-1.09-7.59-1.09s-6.83-25.39-9.08-34.83C415,313.13,408,281,408,281l-2.39,22.25s2.05,8.11.43,20.27-4.34,24.08-4.34,24.08a29.2,29.2,0,0,1-7.82,1,27.82,27.82,0,0,1-9.09-1.68s-2.58-35-3.13-48.7S380,246.55,384.29,230Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.71,305.26s-2.88-2.68-8.17-1.84-7.35,3.94-7.35,3.94C420.79,304.65,430.71,305.26,430.71,305.26Zm-12.43,3c3.16.47,6.3.61,13.11-1C428.11,306.62,418.28,308.23,418.28,308.23Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.71,300.32c0,.48,0,1,.07,1.49a69.29,69.29,0,0,1,13.54-.09C393.36,300.73,386.28,299.64,381.71,300.32Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.88,303.75c0,.45.05.91.08,1.39a72.09,72.09,0,0,0,10.17-1.57C387.51,303.42,382.91,303.68,381.88,303.75Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.25,309.89c-1.65-6.34-1.67-18.55-2.08-29.16-.12-3.2-.25-6.52-.43-10-.68-13.81-2.42-29.22-10.06-38.9l-.57.42c5.14,6.51,7.57,15.7,8.81,25.23-7.23-.62-9.08-7.41-11.61-16.74-.34-1.28-.7-2.6-1.08-4l-.69.18c.38,1.35.74,2.67,1.08,3.94,2.53,9.32,4.53,16.7,12.38,17.28.52,4.2.83,8.46,1,12.57.18,3.52.3,6.83.43,10,.41,10.64.43,22.89,2.1,29.3l.6,2.26c2.2,8.2,4.77,21.87,4.26,43.55.27-.16.52-.32.73-.47.44-21.47-2.11-35.08-4.3-43.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,281l-5.57-26.13s-9.51-.27-15-5.37c1.19,4.51,8.88,8,12.33,8.69l1.06,4.6c-.07,2.47-.15,5.07-.23,7.74-.44,14.77-.76,30,0,33.44,1.51,6.66,1.11,13.07.24,21.78-.78,7.86-2.13,17.6-3,22.58l.71-.09c.85-4.94,2-13.62,3.07-22.45s1.39-15-.36-22c-.83-3.32-.42-19.21,0-33.24.06-1.7.11-3.37.15-5l3.72,16.19.44,21.5Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.61,190.37a28,28,0,0,1-.85-5.31,24.81,24.81,0,0,1,0-2.86c.07-1.23.32-.71,1.22-1.09a.78.78,0,0,0,.39-.69c0-.28,0-.56,0-.84a1.2,1.2,0,0,1,.74-.92,2.7,2.7,0,0,0,.61-.25c.37-.3.25-.9.45-1.34a1.19,1.19,0,0,1,1.54-.5,2,2,0,0,1,1.06,1.38,1,1,0,0,0,.13.33.87.87,0,0,0,.63.2,2.4,2.4,0,0,1,1.64,1.21c.9,1.53.73,3.46,1.13,5.14a8.48,8.48,0,0,0,1.47,3.18c.11.15.26.31.44.28s.27-.27.29-.46c.26-1.84-.66-3.78,0-5.53a5.24,5.24,0,0,1,1-1.62.9.9,0,0,1,.32-.26.63.63,0,0,1,.75.39,8.33,8.33,0,0,1,.29,1.67,24.89,24.89,0,0,0,1.18,4.09,16.88,16.88,0,0,1,1,3.61c.16,1-.1,2.42.3,3.36a2.43,2.43,0,0,0,.43.58c1.41,1.57,9,7.95,11.31,9.69,1.65,1.24,3.31,2.48,5,3.69,0,0,6.22-7.73,9.73-11.64,8.13-9.05,9.37-10.77,16.41-10.15l-6.32,22.21s-6.69,6.36-13.77,12.6c-4.16,3.67-7.17,4.22-13.23-2.06-3.52-3.65-11.11-12.12-12.82-14s-3.55-2.81-5.27-4.29c-2.5-2.15-5.32-4.42-6.44-7.61C335,191.87,334.8,191.13,334.61,190.37Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.3,185.35c-4.55.12-7.76-.15-12,4.65-3.18,3.58-4.37,5.08-4.37,5.08a14.39,14.39,0,0,0,2.35,9.58,20.6,20.6,0,0,0,5.42,5.64l3.26-2.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.66,240c-2.79-8.59-5.63-12.68-5.16-16.69.72-6.17,3.23-13.94,3.41-18.21.62-15.16-2.31-16.68-5-17.84,0,0-4.85-1.05-7.51-1.68-1.6-.38-4.79-.82-4.79-.82-2.45-.09-7.43,0-9.45.19a23.43,23.43,0,0,1-2.79,0l-6.21.44a64.81,64.81,0,0,0-9.31,10.18c-4.73,6.4-6.54,14,.3,19.72,0,0,.33,6,.27,8.65-.28,3.84-1.55,10.74-2.17,18.7C392.76,252.35,418.83,250.07,430.66,240Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--4--inject-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "406.06 204.68 394.66 194.84 403.34 149.28 386.49 134.74 373.36 139.31 367.28 171.21 354.54 160.22 400.46 86.13 382.34 70.5 369.21 75.07 320.1 153.84 316.74 171.44 360.1 208.86 355.08 235.22 371.93 249.77 385.06 245.19 387.49 232.49 388.36 233.24 401.49 228.67 406.06 204.68",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.06 204.68 394.66 194.84 403.34 149.28 386.49 134.74 373.36 139.31 367.28 171.21 354.54 160.22 400.46 86.13 382.34 70.5 369.21 75.07 320.1 153.84 316.74 171.44 360.1 208.86 355.08 235.22 371.93 249.77 385.06 245.19 387.49 232.49 388.36 233.24 401.49 228.67 406.06 204.68",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--4--inject-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "381.53 199.41 390.21 153.86 373.36 139.31 364.67 184.87 341.4 164.79 387.33 90.71 369.21 75.07 320.1 153.84 316.74 171.44 360.1 208.86 355.08 235.22 371.93 249.77 376.96 223.4 388.36 233.24 392.93 209.25 381.53 199.41",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.53 199.41 390.21 153.86 373.36 139.31 364.67 184.87 341.4 164.79 387.33 90.71 369.21 75.07 320.1 153.84 316.74 171.44 360.1 208.86 355.08 235.22 371.93 249.77 376.96 223.4 388.36 233.24 392.93 209.25 381.53 199.41",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "369.21 75.07 387.33 90.71 400.46 86.13 382.34 70.5 369.21 75.07",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.21 75.07 387.33 90.71 400.46 86.13 382.34 70.5 369.21 75.07",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.36 139.31 386.49 134.74 403.34 149.28 390.21 153.86 373.36 139.31",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.36 139.31 386.49 134.74 403.34 149.28 390.21 153.86 373.36 139.31",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.53 199.41 394.66 194.84 406.06 204.68 392.93 209.25 381.53 199.41",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.53 199.41 394.66 194.84 406.06 204.68 392.93 209.25 381.53 199.41",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.4 164.79 354.54 160.22 367.28 171.21 364.67 184.87 341.4 164.79",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.4 164.79 354.54 160.22 367.28 171.21 364.67 184.87 341.4 164.79",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423,167.25a4.24,4.24,0,0,0,2.82-1.17c1.15-1.12,1.66-2.92,3.09-3.66,1-.52,2.23-.37,3.33-.67a4.3,4.3,0,0,0,3.09-3.85c.08-1.83-1-3.61-.64-5.4a20.12,20.12,0,0,1,1.47-3.12,5.17,5.17,0,0,0-2-6.13c-.91-.55-2-.81-2.89-1.31-1.94-1.07-1.64-3.39-3.26-4.81a5.55,5.55,0,0,0-5.23-1.17c-1.24.4-2.45,1.26-3.73,1a7.93,7.93,0,0,1-1.95-1,5.63,5.63,0,0,0-7.07,1.74,5.58,5.58,0,0,1-1.49,1.92c-1.35.8-1.56,1.73-2.19,3.16a4.65,4.65,0,0,0,.18,4.48c.65.91,1.73,1.5,2.2,2.51.89,1.9-.77,4-1,6.06-.39,4.21,3.85,3.89,5.74,6.29a24.29,24.29,0,0,1,1.5,2.57c1.05,1.72,3.25,1,5,1.67a16.3,16.3,0,0,0,1.9.75A4.08,4.08,0,0,0,423,167.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.17,142.87a7.81,7.81,0,0,1,2.66,2.67,1.92,1.92,0,0,1,.26,1.41c-.26.84-1.34,1.07-2.22,1.09-3.34.1-7.14-1.19-8.36-4.66C409,139,416.63,141.87,418.17,142.87Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.3,177.19a3.59,3.59,0,0,1-3.1-1.38c-1.89-1.93-3.2-4.37-5.13-6.27-2.34-2.31-5.44-3.66-8.48-4.94a13.76,13.76,0,0,0-4.68-1.2,4.62,4.62,0,0,1-3.3-2.58,5.88,5.88,0,0,1-.46-4.41c.41-1.38,1.34-2.62,1.43-4.06.07-1-.3-2-.33-3.06a4.79,4.79,0,0,1,3-4.5c1.75-.68,3.87-.31,5.41-1.38,1.19-.83,1.75-2.36,3-3.15a5,5,0,0,1,2.12-.67,10.39,10.39,0,0,1,7,1.73,16.06,16.06,0,0,0,2.48,1.63,23.41,23.41,0,0,0,3.76.76,7.59,7.59,0,0,1,5.47,4.56c.52,1.58.32,3.23.78,4.81s1.62,3,2.4,4.56a10.89,10.89,0,0,1,1.11,6,4.94,4.94,0,0,1-.69,2.26c-1.11,1.68-3.65,2.13-4.4,4a8.24,8.24,0,0,0-.36,1.79,6.79,6.79,0,0,1-6.27,5.43C413.31,177.13,414,177,413.3,177.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.8,182.5c.05-1.51.61-9.06.61-9.06,0,.57,2.71,2.23,5.29-.57s2.42-7,.66-8.76c-2.7-2.67-6.77-.51-7.34,3.16-2.15,1.08-2.83-1.57-1.36-4.53-.11-2.44-2.62-2.84-2.3-8.13-.22-2.65-8.25-5.21-15.3-3.89-1.48,3-3.3,5.5-3,9.35.1,1.36-1,3-1.2,4.8-.7,8,1.4,11.86,3.91,13.33,1.68,1,3.13,1.38,6.15,1.47l-.26,2.51h0c-.11,1.26,0,2.4-1.26,2.75a9.81,9.81,0,0,0,2.35,10.62c8.23-1.77,14.75-8.64,15.35-9.85C415,185,414.74,184,414.8,182.5Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.14,158.59l3.35-.6a1.63,1.63,0,0,0-1.91-1.4A1.79,1.79,0,0,0,393.14,158.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.53,157.73l2.54,2.34a1.66,1.66,0,0,1-2.4.15A1.82,1.82,0,0,1,405.53,157.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.34,161.51a1.46,1.46,0,0,1-1.43,1.43,1.37,1.37,0,0,1-1.41-1.38,1.46,1.46,0,0,1,1.43-1.43A1.37,1.37,0,0,1,396.34,161.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.27,163.12a1.46,1.46,0,0,1-1.43,1.43,1.36,1.36,0,0,1-1.41-1.38,1.47,1.47,0,0,1,1.44-1.43A1.37,1.37,0,0,1,406.27,163.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.73,167.37l4.22,1.84,1.65-7.91C398.82,161.2,396.79,164,394.73,167.37Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.26,
    cy: 171.91,
    r: 1.38,
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.6,171.57a1.27,1.27,0,0,1,0,.34,1.37,1.37,0,0,1-2.29,1A3,3,0,0,1,401.6,171.57Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.88,179.67c4,0,6.83-.66,8.64-1.81a9.83,9.83,0,0,0,3.31-3.37A9.88,9.88,0,0,1,410,179c-3.73,2.84-9.26,2.6-9.26,2.6Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.77,221.73s-.3,1.6-.32,1.88c-.06,3,1.74,5.06,4.55,6.27a154.12,154.12,0,0,0,18.82,6c9.56,2.56,14.43.92,16.18-.8s2.51-5.83,1.43-10.25c-3.31-13.65-4-15.95-5.63-21.25-4.21-13.91-6.61-14.17-13.38-16.09-3.78,4.2-4.25,12.44-2,19.8,3.06,10,5.24,15.44,5.24,15.44a165.85,165.85,0,0,1-16.59-2.58c-3.6-.75-2.58-6-2.58-6Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.16,212.23c.52-2.77.41-3.37-.64-5.38s-1.51-2.94-2-3.69a19.09,19.09,0,0,0-3.18-3.37c-1.08-.58-1.65,1.61-.77,3.07s2.19,3.28,2.19,3.28Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.91,224.78c-.25-.72,2.34-2.5,2.1-3.82s-.48-1.38.26-2.52a2.53,2.53,0,0,0,.26-2.82c-.44-.64,1-1.09.55-2.52a25.63,25.63,0,0,0-2.67-4.89c-.76-1.07-3.87-2.7-5.29-3.36s-1.73.54-1.69,1.45a4.46,4.46,0,0,0,1.14,2.09s-1.65-.56-2,0c-.41.7-.29,2.17,1.34,3.4-1.35-.64-2-.11-1.84,1a4.75,4.75,0,0,0,1.88,2.64c1.35,1.15,3,2.44,3.23,3.85l-.44,2.51Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.91,224.78c-.13-.31.07-.63.19-.9s.33-.52.5-.76a10.86,10.86,0,0,0,.94-1.42,1.28,1.28,0,0,0,.16-.67l-.12-.88a1.6,1.6,0,0,1,.12-1,3,3,0,0,1,.57-.73,4.81,4.81,0,0,0-.27.84,1.38,1.38,0,0,0,.08.77c.09.28.16.57.23.87a1.76,1.76,0,0,1-.18,1.06,6,6,0,0,1-1.14,1.47l-.63.62A1.21,1.21,0,0,0,405.91,224.78Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.57,208.39c.79.32,1.58.64,2.35,1a14.21,14.21,0,0,1,2.27,1.26,11.25,11.25,0,0,1,1.61,2.07A21.24,21.24,0,0,1,408,215c-.58-.63-1.13-1.28-1.66-1.94l-.8-1a6.9,6.9,0,0,0-.79-.88c-.62-.46-1.41-.87-2.11-1.32A18.79,18.79,0,0,1,400.57,208.39Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.7,218.27c-.51-.63-.92-1.34-1.35-2a6.45,6.45,0,0,0-1.63-1.58c-1.27-1-2.57-1.87-3.78-3a21.73,21.73,0,0,1,4.17,2.43,5.38,5.38,0,0,1,1.67,1.84A19.55,19.55,0,0,1,406.7,218.27Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.66,222.68c3.71,0,7.06.46,9.78,3.33-2.15-4.52-6.52-4.53-10.3-4.7Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.9,187.22c6.12,1.45,7.26,1.95,9,4s2.65,4,4.8,10.8c-1.65,4.25-15.19,7.2-15.19,7.2a44.69,44.69,0,0,1-1.86-7.61C420.13,197.92,420.08,191.21,423.9,187.22Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.46,410.93c.61-8.91.92-13.07,1.77-29h0c.08-4.08.23-8.44.5-12.32.92-13.06,2.6-16.17,3.72-20.65s1-16.59,2.69-44.67a144.48,144.48,0,0,1,5.18-31.72h40.21c4.13,17.6,5.31,55.71,5.18,73.86-.06,9.24-.16,57,.07,60.84a12.93,12.93,0,0,0,3.87,8.29c3.31,3.56,5.69,5,9.84,8.09-.6,1.59-9.3,1.53-11.78.32a91.15,91.15,0,0,1-10.38-6.1c-3.42-2.52-4.21-4.05-4.27-7.89,0-.48,0-1.18,0-1.26-.06-2.24-6.53-35.72-7.94-43.28-1.1-5.88.1-17.25.1-17.25l-4.26-28s-3.75,22.31-6.32,33.62c-1.88,8.31-6.55,21.44-9.61,34.73h0c-3.57,13.51-3.86,14.7-6,24.37-1.06,4.88-3.66,21.28-4.84,24.66-3.82,10.89-12.46,5.48-12.95-.54C202,433.07,207.33,412.85,207.46,410.93Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,320.24l3.12-20.18s12-1.43,16.42-5.63c0,0-5.52,7.79-13.69,9.06l-3.44,16.72L246.22,348Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.7,428.18a3.51,3.51,0,0,1-.62,3.55c-1.4,1.23-5.53,3.28-11,2.63s-8.48-2.32-10.69-4.13-5.32-4.37-7.8-4.89c-2.31-.48-6.07-1.74-6.82-2.45s-.68-3.87-.68-3.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,407.9a1.66,1.66,0,0,0-.87,1.09c-.16.87-.16,2-.5,3.42a25.34,25.34,0,0,0-.46,7.7c.32,1.62,5.34,2.95,7.75,3.84a30.43,30.43,0,0,1,7.82,4.82A22.68,22.68,0,0,0,279.38,433c5.46,0,9-1.5,10-3.47,1.33-2.44.25-3.83-6.05-6.67-1.19-.54-5.38-3-6.81-3.84a30.89,30.89,0,0,1-4.3-3.13,24.47,24.47,0,0,1-1.94-1.87,8.84,8.84,0,0,1-1.61-2c-.07-.17-.12-.36-.19-.53a8.48,8.48,0,0,1-.42-1.47c-.11-.52-.18-1.28-.68-1.58a4.06,4.06,0,0,0-2.24-.24,17.88,17.88,0,0,0-2.42.36c-.92.22-3.23.07-3.77.94a4.58,4.58,0,0,0-.49,2.28c0,.37,0,.74,0,1.1,0,.16.07.44-.15.38s-.45-.61-.53-.79c-.18-.41-.3-.85-.49-1.25a3.66,3.66,0,0,0-.79-1.32c-1.06-.86-2.06-.68-2.37-1C254.17,408.87,254.05,408.21,254,407.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.39,423.29c-7.89.62-10.33,5.53-10.63,8.55a18.83,18.83,0,0,0,5.62,1.12c5.46,0,9.2-1.5,10.27-3.47C290.9,427.19,290,425.35,284.39,423.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.55,423.49a.37.37,0,0,1-.24-.08.37.37,0,0,1-.06-.54,9.27,9.27,0,0,1,7.11-2.9.39.39,0,0,1-.08.77,8.61,8.61,0,0,0-6.43,2.61A.41.41,0,0,1,272.55,423.49Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.13,421.55a.4.4,0,0,1-.25-.09.39.39,0,0,1-.06-.54,9.26,9.26,0,0,1,7.11-2.89.39.39,0,0,1-.07.77,8.6,8.6,0,0,0-6.43,2.6A.38.38,0,0,1,269.13,421.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,419.32a.38.38,0,0,1-.24-.09.37.37,0,0,1-.06-.54,9.26,9.26,0,0,1,7.11-2.89.39.39,0,0,1,.35.42.4.4,0,0,1-.43.35,8.62,8.62,0,0,0-6.43,2.6A.36.36,0,0,1,266,419.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.84,417.09a.43.43,0,0,1-.24-.08.38.38,0,0,1-.07-.54c1.49-1.93,4.9-3.23,7.77-2.94a.39.39,0,0,1,.35.42.38.38,0,0,1-.42.34c-2.59-.25-5.76.94-7.09,2.65A.4.4,0,0,1,262.84,417.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.44,438.87c-.62,3.67-1.47,6.06-3,8.08s-4.1,2.43-6.54,1.52-5.46-3-5.82-6.24a20.19,20.19,0,0,1,.41-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.46,410.93c-1,0-1.31,4.89-2.46,9.8-1.23,5.26-2.23,7.28-3.29,11.59-1.2,4.92-.62,7.24.79,10.45s7.28,6.86,10.81,2.87c2.88-3.24,3.41-7.14,3.74-12.15a71.82,71.82,0,0,1,2.07-12.42c.88-4,1.83-7.59,1-8.11a36.13,36.13,0,0,1-1.06,4c-.13.26-.61.91-.65-.15,0-.31.16-1,.16-1.33a1.31,1.31,0,0,0-.8-1.3,10.11,10.11,0,0,0-4.29-1.45c-2-.23-3.76-.49-5,0-.71.27-.76.92-.91,1.54s-.23,1.2-.4,1C206.86,414.89,207.51,411.47,207.46,410.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.11,435.18a12.53,12.53,0,0,0,1.09,7.8c1.41,3.21,7.77,6.92,11.3,2.94a14.2,14.2,0,0,0,2.94-7.05C215,435.33,204.31,432.66,201.11,435.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.79,433.19l-.12-.05a17.73,17.73,0,0,0-9.37-2,.4.4,0,0,1-.43-.34.38.38,0,0,1,.34-.42,18.11,18.11,0,0,1,9.87,2.08.39.39,0,0,1,.12.53A.39.39,0,0,1,214.79,433.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.94,427.48a.37.37,0,0,1-.29-.3.38.38,0,0,1,.29-.46c4.8-1.05,9.68,1.87,9.86,2a.37.37,0,0,1,.11.53.39.39,0,0,1-.54.1s-4.79-2.86-9.26-1.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.49,424a.39.39,0,0,1-.29-.29.38.38,0,0,1,.29-.46c5.29-1.26,9.88,1.85,10,2a.39.39,0,1,1-.47.61s-4.48-3-9.41-1.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.13,420.56a.36.36,0,0,1-.29-.28.39.39,0,0,1,.28-.47c5-1.25,9.92,2,10.11,2.1a.39.39,0,0,1-.46.62s-4.85-3.14-9.46-2A.37.37,0,0,1,207.13,420.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.67,272.59c-1,10.73-1.53,13.68-3.17,38.13-1.59,23.71-.67,30.93-.9,33.79-.54,6.55-3.44,8.81-4.29,24.27-.78,14.16-1.24,31.64-1.24,31.64s1.9,2.62,7.3,3.1c5,.45,7.47-1.42,7.47-1.42s9.23-33,11.8-41.34c3.5-11.28,7.35-34.84,7.35-34.84l3.26,22.67a81.27,81.27,0,0,0,1.06,21.11c2.61,12.71,5.27,26.53,5.27,26.53a16.91,16.91,0,0,0,7.5.93c5.83-.59,7.77-1.94,7.77-1.94s1.64-38.41,1.64-52.43-.54-48.47-1.74-70.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,325.92l4-24.54s8.12-2.14,13.33-7.6c-.39,4.07-7.61,9.28-11,10.09l-4.52,21.75,1.39,23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.56,276.39a33.53,33.53,0,0,0-3,6.44,62.92,62.92,0,0,0-2,6.83,69.24,69.24,0,0,0-1.28,7,44.35,44.35,0,0,0-.47,7.1c.56-2.31,1.09-4.6,1.61-6.89s1-4.58,1.59-6.86,1.1-4.55,1.69-6.82S231.86,278.66,232.56,276.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.46,277.25a26.73,26.73,0,0,0-3.21,3.6,34.4,34.4,0,0,0-2.6,4,30.61,30.61,0,0,0-2,4.41,19.08,19.08,0,0,0-1.09,4.71l2.16-4.25c.73-1.39,1.45-2.78,2.22-4.15s1.52-2.75,2.27-4.14S228.76,278.71,229.46,277.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.62,305.63c-1,7.36-1.94,14.72-2.87,22.08s-1.67,19.22-3,26.48-9.94,35.73-11.06,43.07c1.69-7.23,11.1-35.49,12.53-42.8s2-19.23,2.7-26.62S234.17,313.05,234.62,305.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,305.63,262.24,325c.18,3.23.38,6.45.53,9.67s.34,6.45.29,9.63-.27,34.1.17,40.56c.75-7.2,1.1-34,1.32-40.53,0-6.54-.57-13-1.15-19.42S262,312,261,305.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,393.12l1.09,6.72s2.7,1.72,8.35,1.14,6.47-2.41,6.47-2.41v-6.33s-1.36,1.31-6.52,1.9A22.27,22.27,0,0,1,251,393.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.19,395.73l-.51,6.79s2.22,2.3,7.86,3.05,6.85-.83,6.85-.83l1.47-6.16s-1.62,1-6.78.33A22.3,22.3,0,0,1,208.19,395.73Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.23,219.28c5.24.64,10.74,3.87,20.28,9.14l10.21,5.65s8.56-16.34,11.7-21.64c4.56-7.67,8.19,1.18,7,4.35-2.22,5.93-2.95,12.8-6.65,25.66-1.91,6.64-3.24,9.5-11.55,6.77-6.85-2.24-24.11-8.6-24.11-8.6Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.86,201.71c.49-3.21-2-6.77-2-6.77v4.82Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.88,218.58c5.38.7,7.92,1.62,11.47,3.79s16.57,9.56,16.57,9.56a21.4,21.4,0,0,1,.42,8.14,9.73,9.73,0,0,1-4.11,7.24L262.37,241Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.67,223.26s-4.12,8.35-1.54,23.66c1.18,7,2.05,12.44,1.54,21.74-.44,7.88-2,22.24-2,22.24,8.1,6.89,43.65,7.22,51.95-3.12,0,0-.46-17-.46-30.37,0-10-.56-18.37-1.7-23.09-2.56-10.66-6.38-14.12-8.54-15.74a85.72,85.72,0,0,0-17.49.34,166.16,166.16,0,0,0-19.14,3.45A8.27,8.27,0,0,0,217.67,223.26Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.67,223.26c-7,2.43-8.31,5.62-13.31,14.23a180.56,180.56,0,0,0-12,25.84c-1.94,5.55,1.07,11.51,3.69,12.58,2.06.84,3.75,1.68,6.29-.27a28.31,28.31,0,0,0,5.54-6.1c5-7.8,12.74-21.31,12.74-21.31S226,230,217.67,223.26Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,269.08c1.3-6.65.18-9-.38-13.13s-1.22-10.46-1.62-14.27c-1.89,3.56-3.71,7.35-5.3,10.87Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.26,250.33c.42,2.09,5.52,12.67,13.91,14.51l10.48-17s4.14-10.83-1.4-25.43c-6.29,1.18-9,2.53-12.84,8.65S197.26,250.33,197.26,250.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,245.39c0,1.25.18,2.14,0,6.3s-.37,4.77-.69,9.17c-.34,4.86-1.22,8,1.89,12.94s6.79,3.92,9.94,1.14c1.56-4.83,1.1-12.55-.84-18.15A45.49,45.49,0,0,1,200,246.51Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.8,233.75a1.64,1.64,0,0,0-1.82-.17c-.46.36.17,1.58,1,3.22.57,1.08,1.79,5,3,6.62a8.67,8.67,0,0,1,2.08,5A16.38,16.38,0,0,0,187.8,233.75Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.73,212.64c-3.43-4.91-6.54-8-9.06-13.48-1-2.22-2.69-7.39-1.7-10.52.69-2.19,1.86-4,4.14-4.19a6.3,6.3,0,0,1,1.53-6.18,4.73,4.73,0,0,1,4.78-1.51,4.05,4.05,0,0,1,6.69-2.93,4.28,4.28,0,0,1,4-2.63,4.66,4.66,0,0,1,4.27,2.72c3.17-2.86,8.49-1,8.68,4.54a2.45,2.45,0,0,1,4.09,1.94,6.7,6.7,0,0,0-.18,1.88,1.48,1.48,0,0,0,1.11,1.11,1.5,1.5,0,0,0,1.47-.57,3.05,3.05,0,0,1-3.21,4,2.33,2.33,0,0,1-.68,2.41,2.76,2.76,0,0,1-1.91.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,205.09c-.45,4.21-2.08,6.34-4.78,7.61a17.47,17.47,0,0,1-4.54,1.15l.4,4.5c9.16,9-10.72,10.2-15.43,2.05L230,206.77s-1.55,2.26-4.74.7a6.5,6.5,0,0,1-3-7.66c1.08-3.28,4-3.48,5.61-2.2,1.79,1.43,1.82,2.95,2.6,2.8a2.15,2.15,0,0,0,1.88-1.69c.36-1.4.3-2.78,0-5.74A7.69,7.69,0,0,0,235,190.1a7,7,0,0,0-.85-6.16c3.19-1.61,7,1.52,10.64,1.59,4.12.08,4.12-3.39,6.37-3.35,2,1.4,3.19,5.06,3.36,7.48C254.86,194.39,256.89,196.75,256,205.09Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.67,213.85c-4.85.27-10-.71-12-2.31s-3.16-5.21-3.16-5.21.84,4.65,2.44,6.55,5.1,2.38,7.23,2.64,5.66.22,5.66.22Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.65,191.08l-3.32-1a1.67,1.67,0,0,1,2.12-1.17A1.83,1.83,0,0,1,252.65,191.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.45,193.07l2.78-2.17a1.71,1.71,0,0,0-2.43-.36A1.87,1.87,0,0,0,237.45,193.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.65,194.2a1.49,1.49,0,0,0,1.58,1.34,1.39,1.39,0,0,0,1.31-1.52,1.49,1.49,0,0,0-1.57-1.34A1.4,1.4,0,0,0,249.65,194.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.82,195.54a1.49,1.49,0,0,0,1.58,1.34,1.41,1.41,0,0,0,1.32-1.53,1.5,1.5,0,0,0-1.58-1.33A1.4,1.4,0,0,0,238.82,195.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,200l-4.6,2L244.53,193C246.2,192.52,249.12,196.91,251,200Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.77,205a3,3,0,0,0-2-1.3,4.44,4.44,0,0,0-1.31-.1,2.88,2.88,0,0,0-1.33.33c-.2.12,0,.45.2.44a9,9,0,0,1,2.37,0,5.17,5.17,0,0,1,1.15.38c.3.13.55.33.85.47C245.78,205.19,245.8,205,245.77,205Z",
    style: {
      fill: "#b16668"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M307.89,193.69a64,64,0,1,0-127.92,0v9.38a64,64,0,1,0,127.92,0Zm-64,39.34a39.35,39.35,0,0,1-39-34.65,39.34,39.34,0,0,1,78.12,0A39.35,39.35,0,0,1,243.92,233Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.89,193.69a64,64,0,1,0-127.92,0v9.38a64,64,0,1,0,127.92,0Zm-64,39.34a39.35,39.35,0,0,1-39-34.65,39.34,39.34,0,0,1,78.12,0A39.35,39.35,0,0,1,243.92,233Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.92,139.1a64,64,0,1,0,64,64A64,64,0,0,0,243.92,139.1Zm0,103.31a39.35,39.35,0,1,1,39.36-39.34A39.34,39.34,0,0,1,243.92,242.41Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.92,139.1a64,64,0,1,0,64,64A64,64,0,0,0,243.92,139.1Zm0,103.31a39.35,39.35,0,1,1,39.36-39.34A39.34,39.34,0,0,1,243.92,242.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.93,233a39.33,39.33,0,0,1-39-34.59,37.25,37.25,0,0,0-.3,4.63A39.35,39.35,0,1,0,283,198.44,39.34,39.34,0,0,1,243.93,233Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.93,233a39.33,39.33,0,0,1-39-34.59,37.25,37.25,0,0,0-.3,4.63A39.35,39.35,0,1,0,283,198.44,39.34,39.34,0,0,1,243.93,233Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.63,203.7c.94-1.8.8-2,.05-2.74a5.19,5.19,0,0,0-4.48-1.54,10.61,10.61,0,0,0-3.56.92c-.68.48.17,1.95,2.09,2.1,3,.23,3.13,1,3.13,1a38.11,38.11,0,0,0-3.89-.13,28.81,28.81,0,0,0-4.21,1.27c-1.22.38-1.23,2,.95,2.26l-2.22.69c-1.55.48-2,1.41-.58,2.21a2.41,2.41,0,0,0,1.51.34s-1.69.24-1.64.81c.13,1.63,1.23,1.9,4.8,2.4,3,.43,4.15,1.47,4,2.69l-.15.76s1.2-1,2.26-1.94c.77-.71,1.4-1.48.82-2.76,0,0,1.87-.24,1.82-1.4a6,6,0,0,0-.8-2.41,2.07,2.07,0,0,0,.75-2.06,3.29,3.29,0,0,0-1-1.93Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.71,206.88a11,11,0,0,1,2-.52,6.73,6.73,0,0,1,2.09.35,24.56,24.56,0,0,1,3.87,1.41,24.82,24.82,0,0,1-4-.82,9.7,9.7,0,0,0-1.92-.46C302.11,206.82,301.4,206.91,300.71,206.88Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.42,210.12a4.47,4.47,0,0,1,2.23-.39,11.82,11.82,0,0,1,2.22.36,21,21,0,0,1,4.18,1.53,43.79,43.79,0,0,1-4.33-.94A11.64,11.64,0,0,0,299.42,210.12Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.26,241.75c-1.8-.9-1.81-1.15-1.64-2.19a5.17,5.17,0,0,1,2.72-3.87,10.46,10.46,0,0,1,3.42-1.35c.84,0,1,1.67-.46,2.93-2.32,2-1.75,2.47-1.75,2.47s2-1.61,2.9-2.18a28.9,28.9,0,0,1,4.16-1.45c1.2-.41,2.18.91.56,2.39l2.2-.75c1.54-.52,2.42,0,1.77,1.45a2.38,2.38,0,0,1-1,1.16s1.51-.8,1.81-.31c.85,1.4.11,2.27-2.48,4.77-2.2,2.13-2.49,3.62-1.66,4.52l.57.55s-1.54-.09-3-.26c-1-.12-2-.38-2.3-1.75a3,3,0,0,1-2.61-.63c-.64-.58-.44-1.86-.44-1.86a2.33,2.33,0,0,1-1.88-1.33,2.76,2.76,0,0,1-.29-2Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.17,238.5a10.68,10.68,0,0,0-1.95.77,7.09,7.09,0,0,0-1.49,1.51,23.5,23.5,0,0,0-2.3,3.42,25.76,25.76,0,0,0,2.78-3,10.6,10.6,0,0,1,1.28-1.5C198,239.28,198.63,238.93,199.17,238.5Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.11,240.36a4.65,4.65,0,0,0-2,1,12.56,12.56,0,0,0-1.58,1.6,21,21,0,0,0-2.49,3.69,43.36,43.36,0,0,0,3-3.29A11.64,11.64,0,0,1,202.11,240.36Z",
    style: {
      fill: "#f28f8f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.47,362.21,99.88,348.1,116,346.65s-.68,10.88-.58,15.86c0,2.35,1.7,6.78,1.7,6.78s-6.72,3.48-10.21,2.06-5.8-6.93-5.72-7.94S101.47,362.21,101.47,362.21Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.69,384.4c.22,0,.39,2.05-.83,3.05A15.86,15.86,0,0,1,123.58,390c-5.38-.78-8.27-2.47-10.39-4.29s-5.1-4.37-7.53-4.95a17.5,17.5,0,0,1-6-3.09c-.71-.7-.55-3.77-.55-3.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.47,362.18a.87.87,0,0,0-.83.71c-.18.84-.41,3.29-.79,4.67a24.4,24.4,0,0,0-.67,7.44c.27,1.58,4.54,3.54,6.88,4.47a29.92,29.92,0,0,1,7.56,4.88c2.49,2.1,7.78,4.34,11.3,4.37,4.16,0,8.86-1.2,10-3.08,1.37-2.33,2.39-5-3.72-8-1.16-.55-5.22-3-6.6-3.9-3.73-2.41-6.35-4.61-8-8.78a2.35,2.35,0,0,0-.87-1.29,2,2,0,0,0-1.19-.12,40.84,40.84,0,0,0-6.08,1c-.84.37-2,.81-2,1.85a3.5,3.5,0,0,0,.21,1.06c.07.22.12.5-.07.63s-.42,0-.57-.17a15,15,0,0,1-1.63-2,17.71,17.71,0,0,0-1.55-1.8,10.55,10.55,0,0,1-1.05-.69C101.38,363.13,101.48,362.67,101.47,362.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.62,384.35c-1.06-.89-2.19-1.75-3.32-2.53h0s7.17,4.46,10.14,2.54c1.91-1.23,1-2.79,1-3.28s6.69-3.86,8.53-4h0c.51.28.92.53,1.2.64,4.78,2,5.37,4.43,4.51,7.49-1.11,1.88-5.32,3.77-10.69,3.68C121.47,388.79,116.11,386.45,113.62,384.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,379.63c3.81,1.58,2.16,2.25,1.08,2.39s-7.46-3.69-11.34-6.83c-4-3.27-7.16-7.62-8.66-8.82-.56-.44-1.17-1-1.7-1.5.12-.83.21-1.59.3-2a.87.87,0,0,1,.83-.71c0,.49-.09.95.27,1.32a10.55,10.55,0,0,0,1.05.69,17.71,17.71,0,0,1,1.55,1.8,15,15,0,0,0,1.63,2C109.24,372.23,117.16,378.05,121,379.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.78,381.46a.44.44,0,0,1-.24-.09.37.37,0,0,1,0-.53c1.1-1.29,6.29-4.29,9.1-3.94a.37.37,0,0,1,.33.42.36.36,0,0,1-.42.32c-2.63-.32-7.56,2.66-8.43,3.68A.41.41,0,0,1,121.78,381.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.47,379.37a.35.35,0,0,1-.23-.09.37.37,0,0,1,0-.52c1.11-1.29,6.29-4.29,9.11-3.94a.37.37,0,0,1,.33.41.38.38,0,0,1-.43.33c-2.63-.32-7.55,2.66-8.43,3.68A.39.39,0,0,1,118.47,379.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.16,377.39a.4.4,0,0,1-.23-.08.38.38,0,0,1-.05-.53c1.11-1.29,6.29-4.3,9.11-3.94a.37.37,0,0,1,.33.42.38.38,0,0,1-.43.32c-2.63-.32-7.55,2.66-8.43,3.68A.36.36,0,0,1,115.16,377.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.11,375.15a.36.36,0,0,1-.24-.09.38.38,0,0,1-.05-.53c1.11-1.28,6.31-4.29,9.11-3.93a.36.36,0,0,1,.33.41.38.38,0,0,1-.42.33c-2.63-.33-7.56,2.66-8.44,3.68A.36.36,0,0,1,112.11,375.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11,372.9a.4.4,0,0,1-.23-.08.37.37,0,0,1-.06-.53c1.53-1.82,6.94-4.31,9.76-4a.37.37,0,0,1,.33.42.38.38,0,0,1-.43.32c-2.53-.32-7.72,2.08-9.07,3.7A.36.36,0,0,1,109.11,372.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.85,368.83l3.82-16.94L62,349.28,61.69,366s-1.28,4.5-.33,6.05,11,3.17,11.9,2.14S74.85,368.83,74.85,368.83Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.18,395.52c-.44,3.8-1.24,6.26-2.88,8.31s-4.57,2.41-7.47,1.4-6.57-3.24-7.25-6.64a18.62,18.62,0,0,1,.45-9.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.69,366c-1.21-.06-.88,2.93-1.45,8.05-.62,5.55-3.12,9.89-4,14.33-1,5.08-.82,7.43,1.07,10.8s9,7.33,12.77,3.29c3.08-3.29,3.4-7.32,3.39-12.52a115.44,115.44,0,0,1,.38-13.17c.42-3.84,2-7.39,1-7.95-.11.56-1.14,4.45-1.82,4.39a7.08,7.08,0,0,1,.06-1.46,1.65,1.65,0,0,0-.27-1.29,5.45,5.45,0,0,0-1.95-1c-1.18-.36-3.28-.8-4.48-1-.6-.12-1.21-.22-1.81-.29a5.3,5.3,0,0,0-1.54,0,1,1,0,0,0-.68.45,1.41,1.41,0,0,0-.09.58,4,4,0,0,1-.2,1c-.06.15-.18.32-.36.27a.35.35,0,0,1-.18-.34C61.56,369.52,61.65,366.33,61.69,366Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.58,387c-.16.73-1.11,5.58.36,6.65s2.69-2.6,2.69-2.6,3.9-.58,9.41,2.28c-.33.77.41,3.52,2,3.15s2.44-6,2.45-6c0,5-.4,8.87-3.39,12.07-3.79,4-10.88.09-12.77-3.29s-2.09-5.72-1.07-10.8C56.33,387.87,56.45,387.4,56.58,387Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.05,391.38c-.11,1.87-2.17,1-2.13-1.67s1.43-9.08,2-13.42c.35-6.23.6-10.35,1.81-10.29,0,.07,0,.13,0,.19s-.12,3.56-.14,4c-.21,3.81-.26,11.21-.81,14.65A54.72,54.72,0,0,0,60.05,391.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.39,393.15a51.35,51.35,0,0,0,1.47-6.41c.59-3.41,2.63-10.22,3.63-13.89.33-.6,1.36-4,1.36-4,.84.23,0,3.5-.4,5s-.87,3.16-1.36,5.36c-1.25,4.32-1.37,10.8-2.18,13.29S67.9,394.94,68.39,393.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.15,393.45a.44.44,0,0,1-.16-.06,16.56,16.56,0,0,0-9.26-2,.5.5,0,0,1-.54-.34.37.37,0,0,1,.34-.45,17.33,17.33,0,0,1,9.91,2.14.39.39,0,0,1,.16.55A.42.42,0,0,1,69.15,393.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.36,389.52a.47.47,0,0,1-.15-.06,20.72,20.72,0,0,0-10.37-2.23.49.49,0,0,1-.52-.36.36.36,0,0,1,.36-.43,21.22,21.22,0,0,1,10.95,2.35.41.41,0,0,1,.19.56A.44.44,0,0,1,70.36,389.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.32,383.42a.52.52,0,0,1-.37-.32.38.38,0,0,1,.31-.47c5.49-1,10.72,2.14,10.94,2.27a.4.4,0,0,1,.17.56.48.48,0,0,1-.62.09s-5.13-3-10.24-2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.81,379.82a.46.46,0,0,1-.36-.3.36.36,0,0,1,.29-.48,16.08,16.08,0,0,1,11.17,2.26.4.4,0,0,1,.12.57.47.47,0,0,1-.62.05,15.36,15.36,0,0,0-10.4-2.1A.34.34,0,0,1,60.81,379.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.38,375.79a.48.48,0,0,1-.36-.31.35.35,0,0,1,.28-.47c5.67-1.17,11,2.23,11.24,2.38a.39.39,0,0,1,.14.56.47.47,0,0,1-.62.07s-5.21-3.32-10.48-2.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.11,238.21c-5.32,13-1.83,30.44-2.37,44.62-.64,17-.95,30.28-.95,30.28-.2,2.29-1.5,5.48-2.56,16.74-1.12,11.88-1.07,28.84-1.07,28.84s10,4.28,16.28,2.07c0,0,6.7-25.44,10-39.43,3.07-13.24,5.33-33.94,5.33-33.94l3.64,19.95s-.45,8.56-.24,14.56c.25,7,4,33.68,4,33.68s9.33,5.59,15.82.26c0,0,3.16-39.19,3.37-47.58.41-16.46.88-48.82-1.06-70Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.72,287.39l4.16-26.09s9-1.5,12.87-5.24a16.54,16.54,0,0,1-10,7.7l-4.36,24.16,1,19.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,359.27c2.81,2.19,11,4.07,16.56,2.05l1.13-4.72c-4.22,1.42-12.91.52-17.59-2.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.14,356.13c1.89,1.92,10.66,3.51,15.84.47l.38-4.74c-3.93,2.19-13,1.82-16.8-.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.45,285.16s-.87,21.15-.81,22.69,11.55,4.59,11.85,3.61c.5-1.63.38-5.26,1.37-22.79C68.33,287.44,65.45,285.16,65.45,285.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.07,294.7a4,4,0,0,0-1.09-.09l-1.26-.06a19.73,19.73,0,0,1-2.65-.41,20.65,20.65,0,0,1-2.9-.88c-.78-.29-1.5-.69-2.28-1-.07,0-.08.11,0,.14a10.51,10.51,0,0,0,2.43,1.24,19.39,19.39,0,0,0,5,1.24c.44.05.89.08,1.33.1a2.9,2.9,0,0,0,1.41-.1C76.13,294.87,76.14,294.73,76.07,294.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.06,291.75c-.11-.22-.19-.35-.44-.38a.86.86,0,0,0-.58.15.65.65,0,0,0-.28.48.82.82,0,0,0,1.23.78.6.6,0,0,0,.2-.49A1.16,1.16,0,0,0,71.06,291.75Zm-.22.65a.45.45,0,0,1-.57.1c-.3-.17-.24-.73.12-.77a.46.46,0,0,1,.32.08A.47.47,0,0,1,70.84,292.4Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.13,183.13c5.79,1,8.6,2.52,13,9.5s13.19,26.91,13.19,26.91l19,14.56-11.43,5.13c.33.48-2.7-.68-10.29-4.77-6.74-3.64-7.32-3.65-11.74-11.34-3.93-6.83-9.79-16.72-9.79-16.72Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.35,193h0a14.34,14.34,0,0,0,14.34-14.34V142.87H78.31a12,12,0,0,0-12,12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.42,147.38A8.66,8.66,0,0,0,73,149.2a4.82,4.82,0,0,0,0,1.2A4,4,0,0,0,77,153.65a6.13,6.13,0,0,0,4.73-2.53c1.54-2,3.82-6.58.84-8.22a6.07,6.07,0,0,0-6.33.52A7.82,7.82,0,0,0,73.42,147.38Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.42,147.38A8.66,8.66,0,0,0,73,149.2a4.82,4.82,0,0,0,0,1.2A4,4,0,0,0,77,153.65a6.13,6.13,0,0,0,4.73-2.53c1.54-2,3.82-6.58.84-8.22a6.07,6.07,0,0,0-6.33.52A7.82,7.82,0,0,0,73.42,147.38Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6,224.11c-.33,1.46-3.81,9-5.89,17.15,12.49,16.11,49.48,7.32,52.19-1.74-.58-10.78-1.08-38-3.44-42.9a36.33,36.33,0,0,0-11.33-13.49,65.57,65.57,0,0,0-7.89-1,38.46,38.46,0,0,0-11.83.3A57.33,57.33,0,0,0,73.7,185.6c-4.33,1.81-5.3,7.59-3.89,17C70.46,206.92,74.91,214,72.6,224.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--4--inject-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "170.01 194.78 158.61 184.94 167.29 139.38 150.44 124.84 137.3 129.41 131.22 161.31 118.48 150.32 164.41 76.23 146.29 60.6 133.16 65.17 84.05 143.94 80.69 161.54 124.05 198.96 119.03 225.32 135.88 239.87 149.01 235.29 151.43 222.59 152.31 223.34 165.44 218.77 170.01 194.78",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.01 194.78 158.61 184.94 167.29 139.38 150.44 124.84 137.3 129.41 131.22 161.31 118.48 150.32 164.41 76.23 146.29 60.6 133.16 65.17 84.05 143.94 80.69 161.54 124.05 198.96 119.03 225.32 135.88 239.87 149.01 235.29 151.43 222.59 152.31 223.34 165.44 218.77 170.01 194.78",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--4--inject-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "145.48 189.52 154.16 143.96 137.3 129.41 128.62 174.97 105.35 154.9 151.28 80.81 133.16 65.17 84.05 143.94 80.69 161.55 124.05 198.96 119.03 225.32 135.88 239.87 140.91 213.5 152.31 223.34 156.88 199.35 145.48 189.52",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.48 189.52 154.16 143.96 137.3 129.41 128.62 174.97 105.35 154.9 151.28 80.81 133.16 65.17 84.05 143.94 80.69 161.55 124.05 198.96 119.03 225.32 135.88 239.87 140.91 213.5 152.31 223.34 156.88 199.35 145.48 189.52",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "133.16 65.17 151.28 80.81 164.41 76.23 146.29 60.6 133.16 65.17",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.16 65.17 151.28 80.81 164.41 76.23 146.29 60.6 133.16 65.17",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.3 129.41 150.44 124.84 167.29 139.38 154.16 143.96 137.3 129.41",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.3 129.41 150.44 124.84 167.29 139.38 154.16 143.96 137.3 129.41",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.48 189.52 158.61 184.94 170.01 194.78 156.88 199.35 145.48 189.52",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.48 189.52 158.61 184.94 170.01 194.78 156.88 199.35 145.48 189.52",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.35 154.9 118.48 150.32 131.22 161.31 128.62 174.97 105.35 154.9",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.35 154.9 118.48 150.32 131.22 161.31 128.62 174.97 105.35 154.9",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.43,194.93c-1-.27,1.28-4.12.8-6.63-.24-1.25-1.78-2.4-2.33-.73-1.16,3.51-2.69,4.79-3.71,6.9",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.19,194.47a13.15,13.15,0,0,1-5,5.57c-3.07,2.16-21.15,6-21.15,6s-4.27-2.53-11.55-7.4c-9.23-6.17-17.87-13.53-20.77-13-9.14,2.61-7,15.93-3.44,18.91,2.34,2,5,3.76,14.52,8.83,10.27,5.5,11.77,5.71,14.77,7,5.32,2.25,6.42,1.8,13.11-.57s10.64-4.46,19.53-8.87c4.51-2.23,6.16-3.82,9.56-6.11a14.89,14.89,0,0,0,3.51-3,8.76,8.76,0,0,0,1.93-3.74,3.15,3.15,0,0,1,.2-.76c.13-.22.28-.43.43-.64a5.12,5.12,0,0,0,.78-1.23,7.89,7.89,0,0,0,.26-1.53,4.33,4.33,0,0,1,.1-.71,4.53,4.53,0,0,1,.28-.69,5.61,5.61,0,0,0,.7-1.79,1,1,0,0,0-.38-.91s.48-.68.63-.92a5.61,5.61,0,0,0,.53-1.07.53.53,0,0,0,0-.46.44.44,0,0,0-.21-.17c-1.31-.68-2.57.14-3.6.94-2.68,2.06-3.93,3.92-6.84,5.69-1.58,1-2,1.18-2.65,1.17",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,189.94c-.46.71-1,1.37-1.51,2s-1.08,1.3-1.61,1.95c-.27.32-.52.66-.81,1s-.58.62-.89.9a23.29,23.29,0,0,1-1.91,1.67l.87-.92c.29-.3.59-.61.87-.92s.57-.61.84-.93.52-.65.79-1c.54-.65,1.09-1.29,1.66-1.91Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,193a10.47,10.47,0,0,1-.91,1.76c-.36.54-.74,1.07-1.14,1.58s-.81,1-1.24,1.5a16.46,16.46,0,0,1-1.39,1.38c.41-.51.8-1,1.2-1.54l1.18-1.53,1.19-1.54C148.27,194.14,148.64,193.59,149,193Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.66,163.1l1.17-.36c5.27-2.83,5-9.7,3.73-13.28-2.86-8-11.49-11-16.84-11.27-10.13-.56-15.08,2.06-16.13,7.31-1.37-.12-3.26,1-4.4,2.54-2.49,3.39-5.45,15.21,7.68,27.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.43,171.76a4.68,4.68,0,0,1-4.31-1.95c-2.34-2.8-2.47-5.56-1.25-7.35,1-1.46,3.36-2.33,4.94-1.25s1.71,2,2.32,3.3,3.15,1.25,4-3.69c.75-4.6.54-9.44,2.89-11.44,3.5-3,7.1-2,8.38-.06,1.46-2.11,4.62-2.26,6.89-.93,1.65,1,3.37,2.52,3.19,7.7-.06,1.6,1,4.59,1.12,6.83.46,9-1,11.2-3.42,13.38-1.43,1.3-3.69,2.16-7.06,2.18l.12,4.58s4.1,6,4.24,8.92l-19.27-9.15-.48-12.39A2.86,2.86,0,0,1,80.43,171.76Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.27,153.11l2.65,2.34a1.69,1.69,0,0,1-2.46.21A1.86,1.86,0,0,1,103.27,153.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.17,156.05,90.9,158a1.81,1.81,0,0,1,.62-2.56A2,2,0,0,1,94.17,156.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,150c-.79,1-1.37,2-1.25,5.62.05,1.51-.06,5-1.07,7.1-.88,1.83-1.79,2.92-3.74,3.26a7.12,7.12,0,0,1-3.52-.36c-.69-.32-2.63-1.68-2.39-3.69a4,4,0,0,0,1.42,1,3.87,3.87,0,0,0,1.29.31,3.93,3.93,0,0,0,3.32-1.84c1.31-1.94,1.22-4.56,1.62-6.78.51-2.83,1-6,3.55-7.44,3-1.66,8.47-.92,9.13,2.16A6,6,0,0,0,89,150Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.8 158.29 99.84 167.08 104.61 165.22 98.8 158.29",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.77,161.05a1.39,1.39,0,1,1-1.38-1.38A1.38,1.38,0,0,1,95.77,161.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.24,
    cy: 159.67,
    r: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,169.85a1.38,1.38,0,1,1-1.38-1.39A1.38,1.38,0,0,1,99,169.85Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.28,169.5a1.34,1.34,0,0,0,0,.35,1.38,1.38,0,0,0,1.38,1.38,1.35,1.35,0,0,0,.9-.34A3,3,0,0,0,96.28,169.5Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.07,178.48c-3.9-.15-7.46-.79-9.67-2.16a12.1,12.1,0,0,1-4.07-4.39A8.82,8.82,0,0,0,88,178.17c3.51,2.48,10.12,2.91,10.12,2.91Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.33,236.85c2,0,2.14-.23,2.45-1.24a5.22,5.22,0,0,0-.73-4.68,10.93,10.93,0,0,0-2.47-2.72c-.75-.38-1.65,1.06-.88,2.83,1.2,2.8.54,3.25.54,3.25a38.53,38.53,0,0,0-1.71-3.49,28.42,28.42,0,0,0-3.09-3.14c-.9-.9-2.35-.15-1.55,1.9l-1.65-1.64c-1.15-1.15-2.16-1.09-2.23.51a2.38,2.38,0,0,0,.42,1.5s-1-1.39-1.49-1.08c-1.38.88-1.1,2,.12,5.37,1,2.89.63,4.36-.51,4.8l-.74.21s1.4.62,2.76,1.1c1,.35,2,.55,2.83-.56,0,0,1.08,1.54,2.09.95a6,6,0,0,0,1.75-1.83,2.07,2.07,0,0,0,2.18-.3,3.34,3.34,0,0,0,1.25-1.76Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.89,229.56a10.43,10.43,0,0,1,1.4,1.55,6.8,6.8,0,0,1,.67,2,24.28,24.28,0,0,1,.56,4.08,24.07,24.07,0,0,1-1.15-3.95,11.58,11.58,0,0,0-.49-1.91C144.59,230.77,144.18,230.18,143.89,229.56Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.43,229.93a4.66,4.66,0,0,1,1.38,1.78,12.78,12.78,0,0,1,.71,2.14,21.79,21.79,0,0,1,.61,4.41,41.16,41.16,0,0,1-1.2-4.27A12,12,0,0,0,140.43,229.93Z",
    style: {
      fill: "#f0997a"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFoundImg);
export default __webpack_public_path__ + "static/media/page-not-found-img.f5090b44f7fc02d0bb86d07c7627e972.svg";
export { ForwardRef as ReactComponent };